export default "__VITE_ASSET__BmS6QxAt__"